import useGetAllPayments from 'modules/easyPay/hooks/useGetAllPayments'
import useSetTotalPayment from 'modules/easyPay/hooks/useSetTotalPayment'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function AccessPay() {
    const navigate = useNavigate()
    const { payments, isLoading } = useGetAllPayments(true)
    const { total, commission } = useSetTotalPayment(payments)
    return (
        <div className="bg-green-1 p-4 flex items-center gap-1.5">
            <button
                className="shrink-0 bg-white rounded-full px-4 py-1 text-green-1 text-sm font-bold"
                onClick={() => navigate('/easy-pay')}
            >
                پرداخت آسان
            </button>
            <div className="flex-1 min-w-0 text-right">
                {!isLoading && (
                    <p className="text-heading text-[26px] font-bold leading-tight text-right">
                        {Number(total + commission).toLocaleString()} تومان
                    </p>
                )}
                <p className="text-white text-sm font-normal text-right">
                    تمامی تعهدات قابل پرداخت شما در این ماه
                </p>
            </div>
        </div>
    )
}
